import { getAPIPromise,getValidToken,getAPIPromiseWithError } from "./APIutils";
import { BASE_URL, GET_CITIES_MASTER, GET_AGENCY_MASTER, GET_DEPOT_MASTER, GET_OPERATOR_MASTER, GET_OWNER_MASTER, GET_VEHICLE_OPERATION_TYPE ,
    GET_VEHICLE_SERVICE_TYPE,GET_VEHICLE_APPLICATIONS,GET_VEHICLE_TYPE,GET_ID_TYPE, GET_PROTOCOL_TYPE, APPROVE_ID, APPROVE_PAN, APPROVE_BANK, GET_COUNTRIES_MASTER,GET_CAMERA_MASTER,GET_LANGUAGE,BASE_GPS_MATRIX_STAG_URL,
    GET_SEATING_LAYOUT,
    GET_CAMERA_SERVICE} from "../Constant";
import { masterType } from '../views/Dashboard/vehicleMaster/utils'
import FileDownLoader from "./fileDownloader";

export function fetchVehicleMaster(masterDataType, parentId, pageNo, pageSIze = 10,key=null,status,countryId,countryName) {
    let url = setMasterTypeUrl(masterDataType);
    if(masterDataType === "camera"){
        url = `${BASE_URL}${GET_CAMERA_SERVICE}`
    }
    url = `${url}?pageNo=${pageNo}&pageSize=${pageSIze}`;

    if (parentId) {
        if (parentId.cityId) {
            url = `${url}&cityId=${parentId.cityId}`;
        } if(parentId.agencyId){ url = `${url}&agencyId=${parentId.agencyId}`; }
    }
    if(key && masterDataType){
        if( masterDataType == masterType.country || masterDataType === masterType.seatingLayout || masterDataType === masterType.camera){
            url = `${url}&searchKey=${key}`;
        }
        else{
            url = `${url}&key=${key}`;
        }
    }
    if(status!=undefined){
        url = `${url}&status=${status}`;
        if(masterDataType == "operator"){
            url = `${url}&verified=true`; 
        }
    }
    if(masterDataType == "operator" && status == undefined){
        url = `${url}&verified=all`; 
    }
    if(masterDataType === 'city' && countryId && countryName){
        url = `${url}&country=${countryName}&countryId=${countryId}`;
    }
    return getAPIPromise(url, {
        method: 'get'
    });
}

export function fetchCountryData(){
    let  url = `${BASE_URL}api/master/country?pageNo=0&pageSize=1000`;
    return getAPIPromise(url, {
        method: 'get'
    });
}

export function fetchVehicleMetaData(masterDataType) {
    let url;
    switch (masterDataType) {
        case 'vehicleType': {
            url = `${BASE_URL}${GET_VEHICLE_TYPE}`;
            break;
        }
        case 'operationType': {
            url = `${BASE_URL}${GET_VEHICLE_OPERATION_TYPE}`;
            break;
        }
        case 'serviceType': {
            url = `${BASE_URL}${GET_VEHICLE_SERVICE_TYPE}`;
            break;
        }
        case 'applications': {
            url = `${BASE_URL}${GET_VEHICLE_APPLICATIONS}`;
            break;
        }
    }
    return getAPIPromise(url, {
        method: 'get'
    });
}

export function createMasterData(masterDataType, state,updatedData) {
    let data = state
    let url = setMasterTypeUrl(masterDataType)
    return getAPIPromise(url, {
        method: updatedData ? 'PUT' : 'POST',
        body: masterDataType === masterType.operator || masterDataType === masterType.country ? data : JSON.stringify(data),
        ...(!(masterDataType === masterType.operator || masterDataType === masterType.country ) ? {headers: {
            'Content-Type': 'application/json'
        }} : {})
    });
}

export function updateMasterDataStatus(masterDataType, state) {
    const baseUrl = setMasterTypeUrl(masterDataType);
    const isOwner = masterDataType === masterType.owner;

    let url = isOwner
        ? `${baseUrl}/${state.id}/status`
        : `${baseUrl}/status`;

    url += `?status=${state.status}`;

    if (!isOwner) {
        url += `&${masterIdMappaing[masterDataType]}=${state.id}`;
    }

    return getAPIPromise(url, {
        method: isOwner ? 'PATCH' : 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function upadteMasterDataLiveTracking(masterDataType, state) {
    let url = setMasterTypeUrl(masterDataType);
    url=`${url}/status/liveTracking`;
    url = `${url}?liveTracking=${state.status}`;
    url = `${url}&${masterIdMappaing[masterDataType]}=${state.id}`;
    return getAPIPromise(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

function setMasterTypeUrl(masterDataType) {
    let url;
    switch (masterDataType) {
        case masterType.city: {
            url = `${BASE_URL}${GET_CITIES_MASTER}`;
            break;
        }
        case masterType.country: {
            url = `${BASE_URL}${GET_COUNTRIES_MASTER}`;
            break;
        }
        case masterType.agency: {
            url = `${BASE_URL}${GET_AGENCY_MASTER}`;
            break;
        }
        case masterType.operator: {
            url = `${BASE_URL}${GET_OPERATOR_MASTER}`;
            break;
        }
        case masterType.owner: {
            url = `${BASE_URL}${GET_OWNER_MASTER}`;
            break;
        }
        case masterType.depot: {
            url = `${BASE_URL}${GET_DEPOT_MASTER}`;
            break;
        }
        case masterType.camera: {
            url = `${BASE_URL}${GET_CAMERA_MASTER}`;
            break;
        }
        case masterType.language:{
            url = `${BASE_URL}${GET_LANGUAGE}`;
            break;
        }
        case masterType.seatingLayout:{
            url = `${BASE_URL}${GET_SEATING_LAYOUT}`;
            break;
        }
    }
    return url;
}

export function fetchImgaes(id, docType) {
    let token = localStorage.getItem("token");
    let url = `${BASE_URL}api/master/${docType !== "country"? 'operator' : 'country'}/downloadFile`;
    if (docType !== "country") {
      url = `${url}?operatorId=${id}&docType=${docType}`;
    } else {
      url = `${url}?countryName=${id}`;
    }
    return fetch(url, {
      method: "get",
      headers: {
        Authorization: "Bearer " + token,
        responseType: "blob",
      },
    });
  }  

export function fetchIdType() {
    let  url = `${BASE_URL}${GET_ID_TYPE}`;
    return getAPIPromise(url, {
        method: 'get'
    });
}

export function fetchProtocolType() {
    let  url = `${BASE_URL}${GET_PROTOCOL_TYPE}`;
    return getAPIPromise(url, {
        method: 'get'
    });
}

const masterIdMappaing = {
    city: 'cityId',
    agency: 'agencyId',
    operator: 'operatorId',
    depot: 'depotId',
    owner: 'ownerCode'
};

export function verifyId(operatorId,status){
    let  url = `${BASE_URL}${APPROVE_ID}?operatorId=${operatorId}&status=${status}`;
    return getAPIPromise(url, {
        method: 'put',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}
export function verifyPAN(operatorId,status){
    let  url = `${BASE_URL}${APPROVE_PAN}?operatorId=${operatorId}&status=${status}`;
    return getAPIPromise(url, {
        method: 'put',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}
export function verifyBank(operatorId,status){
    let  url = `${BASE_URL}${APPROVE_BANK}?operatorId=${operatorId}&status=${status}`;
    return getAPIPromise(url, {
        method: 'put',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export function fetchCameraData(searchKey, pageNo, cityId) {
    const url = new URL(`${BASE_URL}api/camerastream/cameraDetails`);
    const params = new URLSearchParams();
    params.set('pageNo', pageNo);
    params.set('pageSize', 10);
    if (searchKey) {
        params.set('searchKey', searchKey);
        params.set('sortKey', 'updatedAt');
        params.set('sortOrder', 'ASC');
    }
    if (cityId) {
        params.set('cityId', cityId);
    }
    url.search = params.toString();

    return getAPIPromise(url.toString(), {
        method: 'GET'
    });
}


export function upsertCameraMasterData(masterDataType, state,updatedData) {
    let data = state
    let url = setMasterTypeUrl(masterDataType);
    if(updatedData && updatedData.cameraId){
        url = `${url}?cameraId=${updatedData.cameraId}`
    }else{
        url = `${url}`
    }
    return getAPIPromise(url, {
        method: updatedData ? 'PUT' : 'POST',
        body: masterDataType === masterType.operator || masterDataType === masterType.country ? data : JSON.stringify(data),
        ...(!(masterDataType === masterType.operator || masterDataType === masterType.country ) ? {headers: {
            'Content-Type': 'application/json'
        }} : {})
    });
}


export function deleteCameraMasterData(cameraId) {
    const url = `${BASE_URL}api/master/camera?cameraId=${cameraId}`
    return getAPIPromise(url, {
        method: 'delete'
    });
}
export function fetchCameraServiceNames(){
    let url=`${BASE_URL}api/master/camera/camera-service-names`
    return getAPIPromise(url,{
        method:'get'
    })
}
export function fetchCameraPositionData(){
    let  url = `${BASE_URL}api/master/camera/cameraPositions`;
    return getAPIPromise(url, {
        method: 'get'
    });
}
export function fetchBusClassification({agencyName,cityId}){
    const url = `${BASE_URL}api/serviceCategory/agency/filter?agencyName=${agencyName}&cityId=${cityId}`;
    return getAPIPromise(url,{
        method:'get'
    })
}

export function fetchAllBusClassification({pageNo}){
    const url = `${BASE_URL}api/serviceCategory/all?pageNo=${pageNo}&pageSize=10`;
    return getAPIPromise(url,{
        method:'get'
    })
}
export function upsertServiceCategory(data,createMode=false){
    let url = `${BASE_URL}api/serviceCategory`
    return getAPIPromise(url, {
        method:!createMode ? 'POST' : 'PUT',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        body: JSON.stringify(data),
    });
}
export function fetchTags(data){
    const url = `${BASE_URL}api/tags/region/${data.value}`
    return getAPIPromise(url,{
        method:'get'
    })
}

export function getCityData(){
    const url = `${BASE_URL}api/master/city?pageNo=0&pageSize=1000`
    return getAPIPromise(url,{
        method:'get'
    })
}

export function fetchCameraBrands(){
    const url = `${BASE_URL}api/master/camera/cameraBrands`
    return getAPIPromise(url,{
        method:'get'
    })
}

export function fetchCameraTypes(){
    const url = `${BASE_URL}api/master/camera/cameraTypes`
    return getAPIPromise(url,{
        method:'get'
    })
}


export function fetchServiceProvider({pageNo}){
    const url = `${BASE_URL}api/serviceProvider/all?pageNo=${pageNo}&pageSize=10`;
    return getAPIPromise(url,{
        method:'get'
    })
}

export function upsertServiceProvider(data,createMode=false){
    let url = `${BASE_URL}api/serviceProvider`;
    return getAPIPromise(url, {
        method:!createMode ? 'POST' : 'PUT',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        body: JSON.stringify(data),
    });
}

export function fetchServiceProviderWithCity({agencyName,cityId}){
    const url = `${BASE_URL}api/serviceProvider/agency/filter?agencyName=${agencyName}&cityId=${cityId}`;
    return getAPIPromise(url,{
        method:'get'
    })
}


export function editDisplayName(data,activeTab){
    let url = `${BASE_URL}api/${activeTab == 'category'?'serviceCategory':'serviceProvider'}/displayName`;
    return getAPIPromise(url, {
        method: 'PUT',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function deleteCategory(data,isMultiDelete,activeTab) {
    const url = `${BASE_URL}api/${activeTab == 'category'?'serviceCategory':'serviceProvider'}?delete=${isMultiDelete}`;
    return getAPIPromise(url, {
        method: 'DELETE',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}

export function getAllLanguages(){
    const url = `${BASE_URL}api/master/languages`;
    return getAPIPromise(url,{
        method: 'GET'
    })
}

export function getAllDepotTypes(){
    const url = `${BASE_URL}api/master/depot/depotTypes`;
    return getAPIPromise(url,{
        method: 'GET'
    })
}

export function fetchDepotMaster({ cityId, pageNo = 0, pageSize = 10, searchKey, depotType }) {
    let url = `${BASE_URL}${GET_DEPOT_MASTER}?pageNo=${pageNo}&pageSize=${pageSize}`;
    if (cityId) {
        url = `${url}&cityId=${cityId}`;
    }
    if (searchKey) {
        url = `${url}&key=${searchKey}`;
    }
    if (depotType) {
        url = `${url}&depotType=${depotType}`;
    }
    return getAPIPromise(url, {
        method: 'GET'
    });
}

export function addLanguagesToCity(data,mode){
    const url = `${BASE_URL}api/master/languages/city`;
    return getAPIPromise(url,{
        method: mode ? 'PUT':'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        },
    })
}

export function deleteLanguageWithCity(cityId,languageIds) {
    const url = `${BASE_URL}api/master/languages/city?cityId=${cityId}&languageIds=${languageIds}`
    return getAPIPromise(url, {
        method: 'delete'
    });
}

export function filterLanguageMasterReport(data){
    const {cityId,countryId,languageId,pageNo} = data;
    let url = `${BASE_URL}api/master/languages/filter?pageNo=${pageNo}&pageSize=10`;
    if(cityId){
        url = `${url}&cityId=${cityId}`;
    }
    if(countryId){
        url = `${url}&countryId=${countryId}`;
    }
    if(languageId){
        url = `${url}&languageId=${languageId}`;
    }
    return getAPIPromise(url, {
        method: 'GET',
    });
}

export function getPanicReport({selectedRegion,startDate,endDate,pageNo,searchString}){
    let  url = `${BASE_GPS_MATRIX_STAG_URL}api/alert/v1?pageNo=${pageNo}&pageSize=10&fromDate=${startDate}&toDate=${endDate}&alertType=PANIC_ALERT&regionId=${selectedRegion}`;  
    if(searchString){
        url = `${url}&searchKey=${searchString}`;
    }
    
    return getAPIPromise(url, {
        method: 'get'
    });
}

export function getPanicReportDetail({startDate,endDate,pageNo,type}){
    const  url = `${BASE_GPS_MATRIX_STAG_URL}api/alert/v1/device/${type}?pageNo=${pageNo}&pageSize=10&fromDate=${startDate}&toDate=${endDate}&alertType=PANIC_ALERT`; 
    return getAPIPromise(url, {
        method: 'get'
    });
}

export function getPanicReportNotification(){
    return getAPIPromise(`${BASE_GPS_MATRIX_STAG_URL}api/alert/v1/panic/notification?previousAlertTimestamp=${localStorage.getItem("previousAlertTimestamp")}`, {
        method: 'get'
    });
}

export function getRegionsForPanicReport(){
    return getAPIPromise(`${BASE_URL}api/region`, {
        method: 'get'
    });
}

export function fetchFuelTypes(){
    return getAPIPromise(`${BASE_URL}api/master/vehicle/fuel-type/v1`, {
        method: 'get'
    });
}

export function updateCameraPassword(camera) {
    let url = `${BASE_URL}api/camerastream/setPassword`;
    const body = {
        cameraId: camera.cameraId,
        cameraPassword: camera.cameraPassword != null ? camera.cameraPassword : ""
    };

    return getAPIPromise(url, {
        method: 'PATCH',
        headers: {
        'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });
}


export async function fetchLiveFeedDetails(cameraid, cameraBrand) {
    const url = `${BASE_URL}api/camerastream/onBoardRtmpCamera`;
    const body = {
        cameraId: cameraid,
        cameraBrand: cameraBrand
    };
    
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    };
    try {
        return await getAPIPromiseWithError(url, options);
    } catch (error) {
        // Consider logging the error here and rethrowing the full error object.
        console.log(error)
        throw error;
    }
}



export async function validateCameraDetails(data) {
    const url = `${BASE_URL}api/master/camera/validate`;
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: data
        };
    
    try {
        const response = await getAPIPromiseWithError(url, options);
        return response;
    } catch (error) {
        if (error.data) {
            throw error.data
        } else {
            throw error;
        }
    }
}

export function getCameraData(searchKey, pageNo, city, agencyId, operatorId, status, region) {
    const url = new URL(`${BASE_URL}api/camerastream/cameraDetails`);
    const params = new URLSearchParams({
        pageNo: pageNo.toString(),
        pageSize: '10',
    });

    if (searchKey) {
        params.append('searchKey', searchKey);
        params.append('sortKey', 'updatedAt');
        params.append('sortOrder', 'ASC');
    }
    if(region) params.append('regionId', region);
    if (city) params.append('city', city);
    if (agencyId) params.append('agencyId', agencyId);
    if (operatorId) params.append('operatorId', operatorId);
    if (status) params.append('isActive', status);
    url.search = params.toString();

    return getAPIPromise(url.toString(), {
        method: 'get'
    });
}


export function exportCameraData(exportKey, data) {
    const basePath = exportKey === "format" 
        ? `${BASE_URL}api/master/camera/export/format` 
        : `${BASE_URL}api/camerastream/exportCameraDetails`;

    const url = new URL(basePath);

    if (exportKey !== "format") {
        const params = new URLSearchParams();
        if(data.selectedRegion) params.append('regionId', data.selectedRegion);
        if (data.selectedCity) params.append('cityId', data.cityId);
        if (data.agencyId) params.append('agencyId', data.agencyId);
        if (data.operatorId) params.append('operatorId', data.operatorId);
        if (data.statusValue) params.append('isActive', data.statusValue);
        if (data.searchKey) params.append('searchKey', data.searchKey);

        url.search = params.toString();
    }

    return getValidToken().then((token) => {
        return FileDownLoader.download(url.toString(), {
            methods: 'GET',
            headers: { Authorization: `Bearer ${token}` }
        });
    });
}

export function exportOwnerData() {
    const basePath = `${BASE_URL}api/master/owners/export`;
    const url = new URL(basePath);
    return getValidToken().then((token) => {
        return FileDownLoader.download(url.toString(), {
            methods: 'GET',
            headers: { Authorization: `Bearer ${token}` }
        });
    });
}

export function fetchOwnerData({ searchKey, pageNo = 0, pageSize = 10, cityId, operatorId, ownerCode }) {
    const url = new URL(`${BASE_URL}${GET_OWNER_MASTER}`);
    const params = new URLSearchParams();
    params.set('pageNo', pageNo.toString());
    params.set('pageSize', pageSize.toString());
    if (searchKey) params.set('searchKey', searchKey);
    if (cityId) params.set('cityId', cityId);
    if (operatorId) params.set('operatorId', operatorId);
    if (ownerCode) params.set('ownerCode', ownerCode);
    url.search = params.toString();

    return getAPIPromise(url.toString(), {
        method: 'GET'
    });
}

export function fetchOwnerList(operatorId = '', cityId = '', status = true) {
    const url = new URL(`${BASE_URL}${GET_OWNER_MASTER}/list`);
    const params = new URLSearchParams();
    if (operatorId) params.set('operatorId', operatorId);
    if (cityId) params.set('cityId', cityId);
    if (status !== undefined) params.set('status', status);
    url.search = params.toString();

    return getAPIPromise(url.toString(), {
        method: 'GET'
    });
}


export function fetchLayoutNames(){
    return getAPIPromise(`${BASE_URL}api/master/vehicle/seating-layout/v1/list`, {
        method: 'get'
    });
}
export async function uploadLayoutData(state, updatedData) {
    const { layoutName, seatingCapacity, layoutFile, layoutId } = state;
    const formData = new FormData();
    formData.append("file", layoutFile);

    const baseUrl = setMasterTypeUrl(masterType.seatingLayout);
    const urlParams = updatedData
        ? `layoutId=${layoutId}&seatingCapacity=${seatingCapacity}`
        : `seatingLayoutName=${encodeURIComponent(layoutName.toUpperCase())}&seatingCapacity=${seatingCapacity}`;
    const url = `${baseUrl}?${urlParams}`;

    try {
        const token = await getValidToken();
        const res = await fetch(url, {
            method: updatedData ? "PUT" : "POST",
            headers: {
                Authorization: `Bearer ${token}`
            },
            body: formData
        });

        const contentType = res.headers.get("content-type") || "";
        const responseBody = contentType.includes("application/json") ? await res.json() : await res.text();

        if (!res.ok) {
            const error = typeof responseBody === 'string' ? { description: responseBody } : responseBody;
            throw error;
        }

        return responseBody;
    } catch (error) {
        console.error("Upload failed:", error);
        throw error;
    }
}

export async function deleteSeatingLayout(layoutId) {
    const url = `${BASE_URL}api/master/vehicle/seating-layout/${layoutId}`;
    try {
        const token = await getValidToken();
        const response = await fetch(url, {
            method: 'DELETE',
            headers: {
                Authorization: 'Bearer ' + token,
                Accept: 'text/csv'
            }
        });
        if(response.status === 406){
            const csvData = await response.text();
            downloadFile(csvData, 'Vehicle-details', 'text/csv');
        }
        return response;

    } catch (error) {
        console.error('Delete error:', error);
    }
}

export function downloadFile(content, fileName, mimeType = 'text/plain') {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

export function getCameraStatus(cameraId) {
    const url = `${BASE_URL}api/master/camera/${cameraId}/config-events/latest`;
    return getAPIPromise(url, {
        method: 'GET'
    });
}

export function restartCamera(cameraId, email) {
    let url = `${BASE_URL}api/master/camera/${cameraId}/restart`;
    url += `?email=${email}`;
    return getAPIPromise(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export function formatSDCard(cameraId, email) {
    let url = `${BASE_URL}api/master/camera/${cameraId}/format-sd-card`;
    url += `?email=${email}`;
    return getAPIPromise(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
}

export function fetchCameraLiveFeed(cameraId, password, cameraBrand) {
    const url = `${BASE_URL}api/master/camera/live-feed`;

    const body = {
        cameraId: cameraId,
        password: password || "",
        cameraBrand: cameraBrand || ""
    };

    return getAPIPromise(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });
}

export function getCameraHealthDetails(cameraId) {
    const url = `${BASE_URL}api/master/camera/${cameraId}/health-details`;
    return getAPIPromise(url, {
        method: 'GET'
    });
}



export function getCameraEventLogs(cameraId, configType, configStatus,  pageNo = 0, pageSize = 10) {
    let url = `${BASE_URL}api/master/camera/${cameraId}/config-events`;
    const params = new URLSearchParams();
    params.append('pageNo', pageNo.toString());
    params.append('pageSize', pageSize.toString());
    if (configType) params.append('configType', configType);
    if (configStatus) params.append('configStatus', configStatus);
    url += `?${params.toString()}`;
    return getAPIPromise(url, { method: 'get' });
}

export function getAllCameraConfigTypes() {
    const url = `${BASE_URL}api/master/camera/config-types`;
    return getAPIPromise(url, { method: 'get' });
}

export function getAllCameraConfigStatus() {
    const url = `${BASE_URL}api/master/camera/config-status`;
    return getAPIPromise(url, { method: 'get' });
}